import { Component, Output, EventEmitter, OnInit, Input, DestroyRef, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Service } from './ctl-gen-birim-arama.service';
import { DxButtonModule, DxToastModule } from 'devextreme-angular';
import { ColumnModel } from '../../../../models/dx-data-table.model';
import { DkDxDataCtlTableComponent } from '../../../dk-dx-data-ctl-table/dk-dx-data-ctl-tablecomponent';
import { Observable } from 'rxjs';
import { GenBirimService } from '../ctl-gen-birim.service';
import { OrtakService } from '../../../../services/ortak.service';
import { CommonModule } from '@angular/common';
import { DataCoreService } from '../../../../services/data-core.service';
import {DlistDto} from "@dabnet-kamu/libs/ui";

@Component({
  selector: 'dk-ctl-gen-birim-arama',
  standalone: true,
  imports: [DkDxDataCtlTableComponent, DxButtonModule,CommonModule, DxToastModule],
  providers: [Service],
  templateUrl: './ctl-gen-birim-arama.component.html',
  styleUrls: ['./ctl-gen-birim-arama.component.scss'],
})
export class CtlGenBirimAramaComponent implements OnInit   {
  private destroyRef = inject(DestroyRef);
  public data: any;
  public checkData: any;
  public toastVisible = false;
  public toastMessage = "Bu birim kullanılıyor. Bir önceki ekrandan düzenleyebilir veya farklı bir birim seçebilirsiniz.";
  public columns: ColumnModel[];
  public selectedData: any = null;
  gridControlsList$: Observable<DlistDto>;
  @Input() control: any;
  @Output() private closePopup = new EventEmitter<string>();
  constructor(
    private service: Service,
    private genBirimService:GenBirimService,
    public ortakService:OrtakService
  ) {

  }

  ngOnInit(): void {
    this.data = this.service.getData(this.control);
    this.gridControlsList$ = this.genBirimService.gridControlsList$;
    this.genBirimService.gridControlsList$.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(x=>{
      this.columns = this.ortakService.setRecursiveFieldData([x],false);
      })

  }

  focusChanged(e: any) {
    this.selectedData = e.row;
  }

  
  onKeyDown(e: any) {
  if (e.event?.key === 'Enter') {
      this.closePopup.emit(this.selectedData);
    }
  }
  
  dblClickRow(e:any){
    this.selectedData = e;
    if(this.genBirimService.checkData){
      this.checkData = this.service.getCheckData(this.selectedData.data.Kod);
      this.checkData.load().done((result: any) => {
        if (result.length > 0) {
          this.toastVisible = true
          return
        } else this.closePopup.emit(this.selectedData);
      });
    }
    else this.closePopup.emit(this.selectedData);
  }
  chooseBtnClick() {
    if(this.genBirimService.checkData){
      this.checkData = this.service.getCheckData(this.selectedData.data.Kod);
      this.checkData.load().done((result: any) => {
        if (result.length > 0) {
          this.toastVisible = true
          return
        } else this.closePopup.emit(this.selectedData);
      });
    }
    else this.closePopup.emit(this.selectedData);

  }

  cancelBtnClick() {
    this.closePopup.emit(null);
  }
}

